import { makeAutoObservable } from 'mobx'
import type { APICreateOrganizationDataGrantRequest } from '@visorpro/client/dist/RestClient/services'

export enum CreateDataGrantModalStep {
    Index,
    ConsumerOrganization,
    Confirmation,
}

export interface CreateDataGrantModalStoreOptions {
    providerOrganizationId: string
    create(body: APICreateOrganizationDataGrantRequest): void
}

export class CreateDataGrantModalStore {
    public step = CreateDataGrantModalStep.Index
    public consumerOrganizationId: string | undefined
    public notes = ''

    constructor(private options: CreateDataGrantModalStoreOptions) {
        makeAutoObservable(this)
    }

    public setStep(step: CreateDataGrantModalStep) {
        this.step = step
    }

    public setConsumerOrganizationId(consumerOrganizationId: string) {
        this.consumerOrganizationId = consumerOrganizationId
    }

    public setNotes(notes: string) {
        this.notes = notes
    }

    public get isReadyForSubmission(): boolean {
        return (
            !!this.consumerOrganizationId &&
            this.consumerOrganizationId !== this.options.providerOrganizationId
        )
    }

    public submit() {
        if (!this.isReadyForSubmission) {
            return
        }

        if (this.step !== CreateDataGrantModalStep.Confirmation) {
            this.setStep(CreateDataGrantModalStep.Confirmation)
            return
        }

        // call POST endpoint and add grant to store
        this.options.create({
            provider_organization_id: this.options.providerOrganizationId,
            consumer_organization_id: this.consumerOrganizationId!,
            notes: this.notes,
        })
    }
}
